import React, { useState } from "react";
import { Button, Modal, Spinner, Toast } from "react-bootstrap";
import {Button as MButton,} from "@material-ui/core";
import download from "js-file-download";
import Axios from "axios";
import { baseUrl } from "../constants/Constant";
import colors from "../theme/colors";
import GetAppIcon from '@material-ui/icons/GetApp';
function DownloadInvoice({ orderId }) {
	const [show, setShow] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [showToast, setShowToast] = useState(false);
	const [toastBgColor, setToastBgColor] = useState("bg-success");
	const [toastMessage, setToastMessage] = useState(
		"Invoice has been downloaded successful!"
	);

	function handleToggle() {
		setShow((prev) => !prev);
	}

	async function handleSubmit() {
		let api = `${baseUrl}v1/admin/invoice/download/${orderId}`;
		try {
			setIsLoading(true);
			const response = await Axios({
				method: "GET",
				url: api,
				headers: {
					Authorization: localStorage.getItem("token"),
					"Content-Type": "application/pdf",
				},
				responseType: "blob",
			});
			if (response.status === 200) {
				download(response.data, `${orderId}.pdf`);
        setShow(false);
				setShowToast(false);
				setIsLoading(false);
			}
		} catch (error) {
			setToastBgColor("bg-danger");
			setToastMessage("Download invoice failed!");
			setShowToast(true);
			setIsLoading(false);
			console.log("Debug error: ", error);
		}
	}

	return (
		<div id="downloadInvoice">
			<MButton variant={"contained"} size={"small"} startIcon={<GetAppIcon/>}
			         style={{backgroundColor: colors.darkBlue, color: colors.white}} onClick={handleToggle}>
				Download Invoice
			</MButton>

			<Toast
				className={toastBgColor}
				onClose={() => setShowToast(false)}
				show={showToast}
				delay={3000}
				autohide
				style={{
					position: "absolute",
					top: 10,
					right: 35,
					zIndex: 1041,
				}}
			>
				<Toast.Header>
					<strong className="mr-auto">{toastMessage}</strong>
				</Toast.Header>
			</Toast>

			<Modal
				show={show}
				centered
				aria-labelledby="contained-modal-title-vcenter"
				onHide={handleToggle}
			>
				<Modal.Header>
					<Modal.Title>Download Invoice #{orderId}</Modal.Title>
				</Modal.Header>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleToggle} disabled={isLoading}>
						Exit
					</Button>
					<Button variant="info" onClick={handleSubmit} disabled={isLoading}>
						{isLoading ? (
							<Spinner
								className="mr-1"
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						) : (
							""
						)}
						{isLoading ? "Loading..." : "Download"}
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}

export default DownloadInvoice;
